export default "__VITE_ASSET__KDfiabJe__"